import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Fields from 'ui/form/FieldsForm';

const styles = theme => ({
    rules: {
        margin: `${theme.spacing(2)}px 0`,
    },
    rule: {
        paddingBottom: 28,
    },
});

const TextInfo = withStyles(styles)(({ classes, name }) => (
    <Typography component="div" className={classes.rules}>
        Sync rules control what actions take place on your accounts in CyberFOX
        Password Manager when changes are sent from {name} to CyberFOX Password
        Manager.
    </Typography>
));

export default function RulesTab({ connector, mode, shortName, onChange }) {
    const disabled = mode === 'details';
    return (
        <React.Fragment>
            <TextInfo name={shortName} />
            <Rules
                rules={connector.sync_rules}
                disabled={disabled}
                onChange={onChange}
            />
        </React.Fragment>
    );
}

function findDefaultRules(rules) {
    return rules.reduce((values, rule) => {
        values[rule.uuid] = rule.action.uuid;
        return values;
    }, {});
}

function findRuleOptions(rule) {
    return rule.available_actions.reduce((options, action) => {
        const label = action.recommended
            ? `${action.name} (Recommended)`
            : action.name;
        options[action.uuid] = label;
        return options;
    }, {});
}
function prepareChanges(changes) {
    return Object.keys(changes).map(uuid => {
        return { uuid, action: changes[uuid] };
    });
}

const Rules = withStyles(styles)(({ classes, rules, disabled, onChange }) => {
    const defaults = findDefaultRules(rules);
    const [changes, setChanges] = useState({});
    const [values, setValues] = useState(defaults);
    const onChangeRule = name => value => {
        const newChanges = { ...changes };
        if (defaults[name] === value) {
            delete newChanges[name];
        } else {
            newChanges[name] = value;
        }
        setChanges(newChanges);
        onChange('rules', prepareChanges(newChanges));
        setValues({ ...values, [name]: value });
    };
    return rules.map(rule => {
        const name = rule.uuid;
        const label = rule.rule.name;
        const options = findRuleOptions(rule);
        return (
            <div className={classes.rule} key={name}>
                <Fields.Select
                    label={label}
                    value={values[name] || ''}
                    options={options}
                    disabled={disabled}
                    onChange={onChangeRule(name)}
                />
            </div>
        );
    });
});
